import { useContext } from 'react'

import { WebapiClientContext } from '../../contexts/webapi-client-context'

export const useWebapiClient = () => useContext(WebapiClientContext)
